/* eslint-disable-next-line */
const focussableElements = 'a:not([disabled]), button:not([disabled]), input:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';

export default {
  mounted: (el) => {
    if (el.matches(focussableElements)) el.focus();
    else el.querySelector(focussableElements)?.focus();
  },
};
